// Kiểm tra chuyển tiền qua code
export const FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST = "FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST";
export const FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS = "FETCH_TRANSFER_CASH_BY_CODE_CREATE_SUCCESS";
export const FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE = "FETCH_TRANSFER_CASH_BY_CODE_CREATE_FAILURE";

// Xác nhận chuyển tiền qua code
export const FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST = "FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST";
export const FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS = "FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_SUCCESS";
export const FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE = "FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_FAILURE";

// Xác thực chuyển tiền qua code
export const FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST = "FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST";
export const FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS = "FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE = "FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_FAILURE";
